import * as React from 'react';
import { UIHeading4, UIText2, UIText3 } from '@cian/ui-kit';
import styles from './TgbSuburban.css';
import { Marquee } from '../../../Marquee';
import { LinkArea } from '../../../LinkArea';

export interface ITgbSuburbanProps {
  image?: string;
  logo?: string;
  titleProject?: string;
  price?: string;
  square?: string;
  url?: string;
  material?: string;
  footnote?: string;
  advertiser?: string;
}

export const TgbSuburban: React.FC<ITgbSuburbanProps> = ({
  image,
  logo,
  titleProject,
  price,
  square,
  url,
  material,
  footnote,
  advertiser,
}) => {
  return (
    <LinkArea href={url} target="_blank" rel="nofollow noopener noreferrer" className={styles['link']}>
      <div className={styles['container']}>
        <div className={styles['images']}>
          <div className={styles['background']} title={titleProject} style={{ backgroundImage: `url(${image})` }}></div>
          <img src={logo} alt={footnote} className={styles['logo']} />
        </div>
        <div className={styles['content']}>
          <a href={url} target="_blank" rel="noreferrer" className={styles['title']}>
            {titleProject}
          </a>
          <div className={styles['price']}>
            <UIHeading4>{price}</UIHeading4>
          </div>
          <UIText2>
            <span>{square}</span>
            <br />
            <span>{material}</span>
          </UIText2>
        </div>
        <div className={styles['footer']}>
          <UIText3 color="gray60_100">{footnote}</UIText3>
          <div className={styles['advertiser']}>
            <Marquee text={advertiser} scrollOffset={30} />
          </div>
        </div>
      </div>
    </LinkArea>
  );
};
